const ICON_MERCATOR = ({ color = "#000", strokeWidth = 3, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <path
      d="M19.026 3.701h5.566l1.664 5.871h-8.894z"
      style={{
        paintOrder: "markers fill stroke",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.7,
        stroke: color,
      }}
      transform="translate(-16.809 -1.637)"
    />
    <path
      d="M17.951 7.494h7.716M18.532 5.441h6.553"
      style={{
        fill: "none",
        paintOrder: "markers fill stroke",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.7,
        stroke: color,
      }}
      transform="translate(-16.809 -1.637)"
    />
    <path
      d="m21.09 3.701-1.495 5.871M22.542 3.701l1.495 5.871"
      style={{
        fill: "none",
        paintOrder: "markers fill stroke",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.7,
        stroke: color,
      }}
      transform="translate(-16.816 -1.637)"
    />
  </svg>
);

export default ICON_MERCATOR;
